export default __webpack_public_path__ + "static/countryBackground-c47b12ee6a57bf6a2769449ebe9f7633.png";